<div mat-dialog-title>
  <h1  fxLayoutAlign="space-between center" fxLayout="row" fxLayout.lt-sm="column">
  <span>situFURNISH</span>
  <div fxLayoutAlign="start center" fxLayout="row" fxLayoutGap="5px">
    <button [disabled]="searchMode" mat-icon-button color="accent" matTooltip="Search Ifcs" (click)="toggleSearchMode()">
      <mat-icon>search</mat-icon>
    </button>
    <button [disabled]="!searchMode" mat-icon-button color="accent" matTooltip="View recents furnishes" (click)="toggleSearchMode()">
      <mat-icon>history</mat-icon>
    </button>
  </div>
</h1>
  <mat-card class="w-100 contrast mat-card-inline-sm" [class.banner-incomplete]="!selectedHome" [class.banner-info]="selectedHome">
    <mat-card-content fxLayoutAlign="center center" fxLayout="row" fxLayout.lt-sm="column">
      <div fxFlex="80" fxLayoutAlign="start center" fxLayout="row">
        <strong *ngIf="!selectedHome">Please select a home to begin</strong>
        <strong *ngIf="selectedHome" class="highlight">{{ selectedHome?.name }}</strong>
      </div>
      <div fxFlex="20" fxLayoutAlign="end center" fxLayout="row" fxLayout.lt-sm="column" fxLayoutGap="0px" fxLayoutGap.lt-sm="18px">
        <div fxLayoutAlign="end center" fxLayout="row" fxLayout.lt-sm="column" fxLayoutAlign.lt-sm="center center" class="date-text">
          <button *ngIf="selectedHome" mat-icon-button color="basic" aria-label="Cancel" (click)="clearHome()">
            <mat-icon>clear</mat-icon>
          </button>
        </div>
      </div>
    </mat-card-content>
  </mat-card>
  <mat-card *ngIf="selectedHome" class="w-100 contrast mat-card-inline-sm" [class.banner-incomplete]="!selectedIfc" [class.banner-info]="selectedIfc">
    <mat-card-content fxLayoutAlign="center center" fxLayout="row" fxLayout.lt-sm="column">
      <div fxFlex="80" fxLayoutAlign="start center" fxLayout="row">
        <strong *ngIf="!selectedIfc">Please select an Ifc to furnish</strong>
        <strong *ngIf="selectedIfc" class="highlight">{{ selectedIfc?.name }}</strong><small *ngIf="selectedIfc" class="text-info m-l-5">{{ selectedIfc.type === 0 ? 'master' : 'option' }}</small>
      </div>
      <div fxFlex="20" fxLayoutAlign="end center" fxLayout="row" fxLayout.lt-sm="column" fxLayoutGap="0px" fxLayoutGap.lt-sm="18px">
        <div fxLayoutAlign="end center" fxLayout="row" fxLayout.lt-sm="column" fxLayoutAlign.lt-sm="center center" class="date-text">
          <button *ngIf="selectedIfc" mat-icon-button color="primary" matTooltip="Load situFURNISH" (click)="openSituFurnish(selectedIfc)">
            <mat-icon>chair</mat-icon>
          </button>
          <mat-icon *ngIf="selectedIfc?.ifcPreviewArtifactId && (selectedIfc?.ifcPreviewStoreysInArtifact | arrayCount:':') === 1" color="accent" matTooltip="1 Floor">looks_one</mat-icon>
          <mat-icon *ngIf="selectedIfc?.ifcPreviewArtifactId && (selectedIfc?.ifcPreviewStoreysInArtifact | arrayCount:':') === 2" color="accent" matTooltip="2 Floors">looks_two</mat-icon>
          <button *ngIf="selectedIfc" mat-icon-button color="basic" aria-label="Cancel" (click)="clearIfc()">
            <mat-icon>clear</mat-icon>
          </button>
        </div>
      </div>
    </mat-card-content>
  </mat-card>
</div>
<div *ngIf="searchMode">
  <ng-container *ngIf="!selectedHome">
    <mat-card class="contrast mat-card-inline-sm">
      <mat-card-content fxLayoutAlign="center center" fxLayout="row" fxLayout.lt-sm="column">
        <mat-form-field>
          <input matInput type="text"
            [formControl]="searchField" 
            (keyup)="doFilter($event.target.value)"
            (keyup.esc)="$event.target.value=''; doFilter('')"
            placeholder="Filter homes by name">
        </mat-form-field>
      </mat-card-content>
    </mat-card>
    <ng-container *ngFor="let item of filteredHomes">
      <mat-card class="contrast card-link mat-card-inline-sm" (click)="selectHome(item)">
        <mat-card-content fxLayoutAlign="center center" fxLayout="row" fxLayout.lt-sm="column">
          <div fxFlex="80" fxLayoutAlign="start center" fxLayout="row">
            <strong [innerHtml]="item?.name | encodeHtml | highlight: searchField.value"></strong>
          </div>
          <div fxFlex="20" fxLayoutAlign="end center" fxLayout="row" fxLayout.lt-sm="column" fxLayoutGap="0px" fxLayoutGap.lt-sm="18px">
            <div fxLayoutAlign="end center" fxLayout="row" fxLayout.lt-sm="column" fxLayoutAlign.lt-sm="center center" class="date-text">
            </div>
          </div>
        </mat-card-content>
      </mat-card>
    </ng-container>
  </ng-container>
  <ng-container *ngIf="selectedHome">
    <mat-card class="contrast mat-card-inline-sm">
      <mat-card-content fxLayoutAlign="center center" fxLayout="row" fxLayout.lt-sm="column">
        <mat-form-field>
          <input matInput type="text"
            [formControl]="searchIfcField"
            (keyup)="doIfcFilter($event.target.value)"
            (keyup.esc)="$event.target.value=''; doIfcFilter('')"
            placeholder="Filter ifc files by name">
        </mat-form-field>
      </mat-card-content>
    </mat-card>
    <ng-container *ngFor="let item of filteredIfcFiles">
      <mat-card class="contrast card-link mat-card-inline-sm" (click)="selectIfc(item)">
        <mat-card-content fxLayoutAlign="center center" fxLayout="row" fxLayout.lt-sm="column">
          <div fxFlex="80" fxLayoutAlign="start center" fxLayout="row" fxLayoutGap="4px">
            <strong [innerHtml]="item?.name | encodeHtml | highlight: searchIfcField.value"></strong><small class="text-info">{{ item.type === 0 ? 'master' : 'option' }}</small>
          </div>
          <div fxFlex="20" fxLayoutAlign="end center" fxLayout="row" fxLayout.lt-sm="column" fxLayoutGap="0px" fxLayoutGap.lt-sm="18px">
            <div fxLayoutAlign="end center" fxLayout="row" fxLayout.lt-sm="column" fxLayoutAlign.lt-sm="center center" class="date-text">
              <mat-icon *ngIf="item?.ifcPreviewArtifactId" color="primary" matTooltip="Ifc preview available">preview</mat-icon>
              <mat-icon *ngIf="item?.ifcPreviewArtifactId && (item?.ifcPreviewStoreysInArtifact | arrayCount:':') === 1" color="accent" matTooltip="1 Floor">looks_one</mat-icon>
              <mat-icon *ngIf="item?.ifcPreviewArtifactId && (item?.ifcPreviewStoreysInArtifact | arrayCount:':') === 2" color="accent" matTooltip="2 Floors">looks_two</mat-icon>
            </div>
          </div>
        </mat-card-content>
      </mat-card>
    </ng-container>
  </ng-container>
</div>
<div *ngIf="!searchMode">
  <mat-card class="contrast mat-card-inline-sm">
    <mat-card-content fxLayoutAlign="center center" fxLayout="row" fxLayout.lt-sm="column">
      <mat-form-field>
        <input matInput type="text"
          [formControl]="searchArtifactsField"
          (keyup)="doArtifactFilter($event.target.value)"
          (keyup.esc)="$event.target.value=''; doArtifactFilter('')"
          placeholder="Filter recent furnishes by name">
      </mat-form-field>
    </mat-card-content>
  </mat-card>
  <ng-container *ngFor="let item of filteredArtifacts">
    <mat-card class="contrast card-link mat-card-inline-sm" (click)="selectArtifact(item)">
      <mat-card-content fxLayoutAlign="center center" fxLayout="row" fxLayout.lt-sm="column">
        <div fxFlex="80" fxLayoutAlign="start center" fxLayout="row" fxLayoutGap="4px">
          <strong matTooltip="Home name" [innerHtml]="item?.home | encodeHtml | highlight: searchArtifactsField.value"></strong>
            <span>></span>
          <small matTooltip="Ifc type">{{ item.isMasterFile ? 'master' : 'option' }}</small>
            <span>></span>
          <strong matTooltip="Ifc name" [innerHtml]="item?.ifcName | encodeHtml | highlight: searchArtifactsField.value"></strong>
        </div>
        <div fxFlex="30" fxLayoutAlign="end center" fxLayout="row" fxLayout.lt-sm="column" fxLayoutGap="0px" fxLayoutGap.lt-sm="18px">
          <div fxLayoutAlign="end center" fxLayout="row" fxLayout.lt-sm="column" fxLayoutAlign.lt-sm="center center" class="date-text">
            <small matTooltip="Updated {{ item?.dateAdded | date:'long'}}" fxLayoutAlign="end center" fxLayout="row"><mat-icon style="transform: scale(0.7)">update</mat-icon><span class="text-info">{{ item?.dateAdded | date:'medium'}}</span></small>
          </div>
        </div>
      </mat-card-content>
    </mat-card>
  </ng-container>
</div>